import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import FormItem from '../../Atoms/FormItem';
import TimeInput from '../../Atoms/TimeInput';

/*
#tailwind
*/

const TimeInputField = ({
  className,
  deps,
  disabled,
  label,
  message,
  mode,
  name,
  orientation,
  placeholder,
  required,
  toolTipText,
  validate,
}) => {
  const { control, trigger } = useFormContext();

  const rules = {
    required,
    validate,
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value, name: _name }, fieldState: { error, isDirty } }) => (
        <FormItem
          message={error?.message || message}
          orientation={orientation}
          context={error ? 'error' : 'default'}
          name={_name}
          toolTipText={toolTipText}
          label={label}
          className={className}
        >
          <TimeInput
            placeholder={placeholder}
            mode={mode}
            onChange={(e) => {
              onChange(e);
              trigger(deps);
            }}
            onBlur={onBlur}
            value={value}
            disabled={disabled}
          />
        </FormItem>
      )}
    />
  );
};
TimeInputField.propTypes = {
  className: PropTypes.string,
  deps: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  label: PropTypes.node,
  maxLength: PropTypes.shape({ value: PropTypes.number, message: PropTypes.string }),
  message: PropTypes.string,
  minLength: PropTypes.shape({ value: PropTypes.number, message: PropTypes.string }),
  mode: PropTypes.oneOf(['filled', 'outlined']),
  name: PropTypes.string,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  pattern: PropTypes.shape({ value: PropTypes.instanceOf(RegExp), message: PropTypes.string }),
  placeholder: PropTypes.string,
  required: PropTypes.string,
  toolTipText: PropTypes.node,
  validate: PropTypes.func,
};

TimeInputField.defaultProps = {
  className: undefined,
  deps: [],
  disabled: false,
  label: undefined,
  maxLength: undefined,
  message: undefined,
  minLength: undefined,
  mode: 'filled',
  name: undefined,
  orientation: 'vertical',
  pattern: undefined,
  placeholder: undefined,
  required: undefined,
  toolTipText: undefined,
  validate: undefined,
};

export default TimeInputField;
